import { IUIPopoverConfig } from '@bannerflow/ui';

export const POPOVER_CONFIG: IUIPopoverConfig = {
  minWidth: '333px',
  maxWidth: '400px',
  width: '430px',
  position: 'bottom',
  panelClass: 'ui-card-popover',
  offset: { x: 24 - 350 / 2, y: 12 }
};
